/**
 * ButtonDoorTile - Door that opens when buttons are pressed
 */

import { BaseTile, TextureDescriptor } from "./BaseTile";
import { TILE } from "../constants/gameConstants";
import { TileIndex } from "../types";

export class ButtonDoorTile extends BaseTile {
  private isOpen: boolean = false;
  private startOpen: boolean = false;

  constructor({ col, row, id, startOpen }: { col: number; row: number; id?: string, startOpen?: boolean }) {
    super(id ?? `buttondoor-${col}-${row}`, col, row);
    this.startOpen = startOpen ?? false;
    this.isOpen = this.startOpen;
  }

  tileType(): TileIndex {
    return this.isOpen ? TILE.BUTTON_DOOR_OPEN : TILE.BUTTON_DOOR;
  }

  textureDescriptor(): TextureDescriptor {
    return {
      type: "png",
      path: this.isOpen ? "tiles/button-door-open.png" : "tiles/button-door-closed.png"
    };
  }

  /**
   * Set the open/closed state of the door
   */
  setOpenBasedOnButtonsPressed(buttonsPressed: number): void {
    if (buttonsPressed % 2 === 1) {
      this.isOpen = !this.startOpen;
    } else {
      this.isOpen = this.startOpen;
    }
  }

  /**
   * Get the current open/closed state
   */
  getIsOpen(): boolean {
    return this.isOpen;
  }

  clone(): ButtonDoorTile {
    const copy = new ButtonDoorTile({ col: this.col, row: this.row, id: this.id, startOpen: this.startOpen });
    copy.sprite = this.sprite;
    copy.isOpen = this.isOpen;
    copy.startOpen = this.startOpen;
    return copy;
  }

  toJSON(): Record<string, any> {
    return {
      type: "buttonDoor",
      id: this.id,
      col: this.col,
      row: this.row,
      isOpen: this.isOpen
    };
  }
}
